/**
 * Wire-Format der SignalR-Live-Updates. 1:1 spiegelt das Backend (Craftly.Application.Notifications.RealtimeEvent) —
 * Änderungen brauchen Server-Sync.
 *
 * Der `type` ist ein Discriminator; Konsumenten filtern damit per RxJS `filter()`.
 */
export interface RealtimeEvent {
  type: RealtimeEventType;
  payload: RealtimeEventPayload;
  timestamp: string;
}

export interface RealtimeEventPayload {
  anfrageId?: string;
  matchId?: string;
  offerId?: string;
  bookingId?: string;
  status?: string;
  message?: string;
}

/**
 * Stabile String-IDs der Event-Typen — der Server schickt diese als `RealtimeEvent.type`.
 * Anders als ein TS-Enum bleiben die Werte beim Tree-Shake erhalten und matchen mit
 * der Backend-Konstante `RealtimeEventTypes` ohne Reflection.
 */
export const RealtimeEventType = {
  // Anfrage / Match
  AnfrageMatched:       'anfrage.matched',
  AnfrageWithdrawn:     'anfrage.withdrawn',
  AnfrageHandwerkerAssigned: 'anfrage.handwerker_assigned',

  // Offers
  OfferSubmitted:       'offer.submitted',
  OfferRejected:        'offer.rejected',
  OfferAccepted:        'offer.accepted',
  OfferPassedOver:      'offer.passed_over',

  // Bookings
  BookingStatusChanged: 'booking.status_changed',
  BookingReleased:      'booking.released',
  BookingDisputed:      'booking.disputed',

  // Inbox-Tick: signalisiert eine neue persistente Benachrichtigung. Das
  // Frontend antwortet darauf mit /api/benachrichtigungen-Reload statt
  // den Body 1:1 aus dem Event-Payload zu lesen — so bleibt der Wire-Type
  // schlank und der Server bleibt Source-of-Truth für Title/Body.
  NotificationCreated:  'notification.created',
} as const;

export type RealtimeEventType = typeof RealtimeEventType[keyof typeof RealtimeEventType];
